import React from 'react';
import { SectionWrapper } from '../ui/SectionWrapper';
import { FadeUp } from '../ui/FadeUp';
export function GuaranteeSection() {
  return <SectionWrapper bgColor="ivory" id="garantia" className="!py-12" data-id="element-68">
      <FadeUp data-id="element-69">
        <div className="border-[1.5px] border-border-custom rounded-[12px] p-[28px_22px] flex flex-col items-center text-center gap-4" data-id="element-70">
          <div className="w-[52px] h-[52px] bg-plum rounded-full flex items-center justify-center text-[22px] text-white relative" data-id="element-71">
            🛡
            <div className="absolute -inset-1 rounded-full border border-plum opacity-30" data-id="element-72" />
          </div>

          <p className="font-serif text-[26px] font-medium text-charcoal" data-id="element-73">
            Garantía Blindaje 7 Días
          </p>

          <p className="text-[13px] text-muted leading-[1.7]" data-id="element-74">
            Si sentís que este sistema no te aporta la claridad y estructura que
            buscás, te devolvemos el 100% de tu inversión. Sin preguntas
            incómodas. Queremos que tu decisión sea tan tranquila como el
            resultado que buscás.
          </p>
        </div>
      </FadeUp>
    </SectionWrapper>;
}